var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar/location/C-store") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avatar/location/C-store",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#116C3A",
    points: "61 34 19 34 16 44 64 44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#51C25D",
    points: "11 23 69.001 23 69.001 11 11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,44 C47,41.7906667 45.2093333,40 43,40 C40.7906667,40 39,41.7906667 39,44 L47,44 Z",
    id: "Fill-3",
    fill: "#51C25D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,44 C57,41.7906667 55.2093333,40 53,40 C50.7906667,40 49,41.7906667 49,44 L57,44 Z",
    id: "Fill-3-Copy",
    fill: "#51C25D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,44 C67,41.7906667 65.2093333,40 63,40 C60.7906667,40 59,41.7906667 59,44 L67,44 Z",
    id: "Fill-3-Copy-2",
    fill: "#51C25D"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#DEDFE1",
    points: "11 63 69 63 69 44 11 44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#DEDFE1",
    points: "19 38 14 38 15 44 18 44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11-Copy",
    fill: "#DEDFE1",
    points: "25 38 20 38 21 44 24 44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11-Copy-2",
    fill: "#DEDFE1",
    points: "31 38 26 38 27 44 30 44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#DEDFE1",
    points: "58 32 46 32 49 34 55 34"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14-Copy",
    fill: "#DEDFE1",
    points: "58 30 46 30 49 32 55 32"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14-Copy-2",
    fill: "#DEDFE1",
    points: "58 28 46 28 49 30 55 30"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#51C25D",
    points: "11 49 69 49 69 44 11 44"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCStore);
export default __webpack_public_path__ + "static/media/c-store.1192ea1dd99c81fbc4ca2683990c6bd1.svg";
export { ForwardRef as ReactComponent };